import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const ConfigCtx = createContext(null);
export const useConfig = () => useContext(ConfigCtx);

export function ConfigProvider({ children }) {
  const [config, setConfig] = useState(null);
  const refresh = useCallback(() => api.config().then(setConfig).catch(() => {}), []);
  useEffect(() => { refresh(); }, [refresh]);
  return <ConfigCtx.Provider value={{ config, refresh }}>{children}</ConfigCtx.Provider>;
}
